function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.71 68.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50.34,54.48c.29.13,1.29.55,1.61.64,3.54.96,7.2-1.13,8.16-4.68.96-3.54-1.13-7.2-4.68-8.16-3.54-.96-7.2,1.13-8.16,4.67-.13.48-.2.96-.22,1.44-.79-.11-1.59-.14-2.34,0-4.17.73-8.73.97-11.34.85",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,58.4l.9,10.02M94.82,68.42l-2.63-28.82c-.97-7.88-7.39-11.89-13.65-11.34-6.47.57-10.71,5.97-11.5,12.27-1.24,9.93-8.25,15.77-17.28,16.56-.35.03-.7.1-1.02.19M75.56,50.06c-3.64,9.03-12.81,16.37-25.23,17.26-1.35,0-1.85-.42-1.85-.42M69.19,25.41c-6.37,0-11.53-5.16-11.53-11.53s5.16-11.53,11.53-11.53,11.53,5.16,11.53,11.53-5.16,11.53-11.53,11.53ZM26.15,58.17l-.92,10.25M.88,68.42l2.69-29.47c.99-8.06,7.56-12.16,13.96-11.6,6.62.58,10.95,6.11,11.76,12.55,1.27,10.15,8.44,16.12,17.67,16.93,2.89.25,5,2.79,4.78,5.69-.25,3.25-2.99,4.77-5.34,4.77h-.01c-12.71-.91-22.08-8.42-25.8-17.65M27.15,24.47c6.51,0,11.79-5.28,11.79-11.79S33.66.89,27.15.89s-11.79,5.28-11.79,11.79,5.28,11.79,11.79,11.79Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.77px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico01);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-01.1201175028a370ec352b3d81c4c3c6aa.svg";
export { ForwardRef as ReactComponent };